import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTimeMostOfTheTimeGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.73 17.036-.382-1.26a3.198 3.198 0 0 0 1.905-1.823h-9v4.767h29.494v-4.767H35.32c-.405 1.437-1.453 2.608-2.855 3.083l-.381-1.26a3.198 3.198 0 0 0 1.904-1.823H19.584c-.404 1.437-1.453 2.608-2.855 3.083Zm18.77-4.407H40V40H8V12.63h3.007c0-2.553 1.964-4.629 4.38-4.629 2.414 0 4.379 2.076 4.379 4.629h6.975c0-2.553 1.964-4.629 4.38-4.629 2.415 0 4.38 2.076 4.38 4.629Zm-7.506 0c0-1.822 1.403-3.305 3.127-3.305 1.723 0 3.126 1.483 3.126 3.305h-6.253ZM15.386 9.324c-1.723 0-3.127 1.483-3.127 3.305h6.254c0-1.822-1.403-3.305-3.127-3.305ZM9.253 38.687h29.494V20.076H9.253v18.61Zm7.767-6.26-2.085-2.193.892-.943 1.193 1.271 3.558-3.76.891.932-4.45 4.692Zm9.16 0-2.085-2.193.892-.943 1.193 1.271 3.558-3.76.881.932-4.44 4.692Z",
    fill: "currentColor"
  }));
}

export { SvgTimeMostOfTheTimeGlyph as default };
